import { ResourcesConfig } from 'aws-amplify';

const userPoolId = import.meta.env.VITE_USER_POOL_ID;
const userPoolClientId = import.meta.env.VITE_USER_CLIENT_ID;
const hostedLoginDomain = import.meta.env.VITE_USER_HOSTED_LOGIN_DOMAIN;
export const callbackUrl = import.meta.env.VITE_USER_CALLBACK_URL;
export const cis2Enabled = import.meta.env.VITE_CIS2_ENABLED;
export const cis2IdpName = import.meta.env.VITE_CIS2_IDP_NAME;

export const authConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolClientId,
      userPoolId,
      loginWith: {
        oauth: {
          domain: hostedLoginDomain,
          scopes: ['openid'],
          redirectSignIn: [callbackUrl],
          redirectSignOut: [callbackUrl],
          responseType: 'code',
        },
        username: true,
        email: false,
        phone: false,
      },
    },
  },
};
